import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import services from 'api/services';
import { useFreecodeContextData } from 'hooks/useContext';
import { Modal, Header, Body, Footer } from 'components/Modals/modalElements';
import { FreecodeButton } from 'components/Button/RectangleButton';
import { SearchSelect } from 'components/SearchSelect/SearchSelect';

const { FreecodeCreatorService, CompanyService } = services;

export default function MoveTestToCompanyModal({ closeModal }) {
  const categoryOptions = { code: 'Code Test', challenge: 'Challenge', exercise: 'Exercise' };

  const { test, setTest } = useFreecodeContextData();

  const [companyId, setCompanyId] = useState(test.company);
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const loadCompanies = async () => {
      try {
        let companiesList = await CompanyService.getSuperAdminCompanies();
        setCompanies(
          companiesList.map((company) => {
            return { ...company, label: company.name, value: company.name };
          })
        );
      } catch (e) {
        toast.error(typeof e === 'string' ? e : e?.message || 'Could not load companies');
      } finally {
        setLoading(false);
      }
    };
    loadCompanies();
  }, []);

  const moveTestToCompany = async () => {
    try {
      setLoading(true);
      let response = await FreecodeCreatorService.moveFreecodeTest(test._id, companyId);
      setTest(response);
      toast.success('Test moved successfully');
      closeModal();
    } catch (e) {
      toast.error(typeof e === 'string' ? e : e?.message || 'Could not move test');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isFreecodeModal>
      <Header isFreecodeModal>Move {categoryOptions[test.category]}</Header>
      <Body>
        <SearchSelect
          value={{ value: companyId, label: companies.find((company) => company._id === companyId)?.name }}
          options={companies}
          disabled={loading}
          isSearchable={true}
          placeholder="Company"
          onChange={(response) => setCompanyId(response._id)}
        />
      </Body>
      <Footer isFreecodeModal>
        <FreecodeButton isFreecodeButton onClick={closeModal} disabled={loading}>
          Cancel
        </FreecodeButton>
        <FreecodeButton isFreecodeButton onClick={() => moveTestToCompany()} disabled={loading}>
          Update
        </FreecodeButton>
      </Footer>
    </Modal>
  );
}
